export const FETCH_CUSTOMERS_REQUEST = 'FETCH_CUSTOMERS_REQUEST';
export const FETCH_CUSTOMERS_SUCCESS = 'FETCH_CUSTOMERS_SUCCESS';
export const FETCH_CUSTOMERS_FAILURE = 'FETCH_CUSTOMERS_FAILURE';

export const SWITCH_CUSTOMER = 'SWITCH_CUSTOMER';
export const SWITCH_CUSTOMER_CANCEL = 'SWITCH_CUSTOMER_CANCEL';

export const SELECT_CUSTOMER_REQUEST = 'SELECT_CUSTOMER_REQUEST';
export const SELECT_CUSTOMER_SUCCESS = 'SELECT_CUSTOMER_SUCCESS';
export const SELECT_CUSTOMER_FAILURE = 'SELECT_CUSTOMER_FAILURE';

export const fetchCustomersRequest = () => ({
  type: FETCH_CUSTOMERS_REQUEST
});

export const fetchCustomersSuccess = response => ({
  type: FETCH_CUSTOMERS_SUCCESS,
  payload: response
});

export const fetchCustomersFailure = err => ({
  type: FETCH_CUSTOMERS_FAILURE,
  payload: err,
  error: true
});

export const switchCustomer = () => ({
  type: SWITCH_CUSTOMER
});

export const switchCustomerCancel = () => ({
  type: SWITCH_CUSTOMER_CANCEL
});

export const selectCustomerRequest = id => ({
  type: SELECT_CUSTOMER_REQUEST,
  payload: { id }
});

export const selectCustomerSuccess = id => ({
  type: SELECT_CUSTOMER_SUCCESS,
  payload: { id }
});

export const selectCustomerFailure = err => ({
  type: SELECT_CUSTOMER_FAILURE,
  payload: err,
  error: true
});



// WEBPACK FOOTER //
// ./src/store/customers/actions.js